<template>
  <v-app-bar
    app
    color="white"
    elevation="0"
    height="80"
    class="agent-header"
    flat
  >
    <v-container class="d-flex align-center px-6">
      <!-- Logo -->
      <div class="agent-logo">
        <router-link to="/agents" class="logo-link">
          <img
            src="@/assets/img/logo.png"
            alt="AutoSyncX™"
            height="85"
            class="logo-image"
          />
          <div class="logo-text">
            <span class="brand-name">AutoSyncX™</span>
            <span class="agent-badge">Agent Portal</span>
          </div>
        </router-link>
      </div>

      <v-spacer></v-spacer>

      <!-- Navigation Menu -->
      <div class="header-nav d-none d-md-flex">
        <v-btn
          text
          class="nav-btn"
          @click="scrollToSection('features')"
        >
          Features
        </v-btn>
        <v-btn
          text
          class="nav-btn"
          @click="scrollToSection('how-it-works')"
        >
          How It Works
        </v-btn>
        <v-btn
          text
          class="nav-btn"
          @click="scrollToSection('testimonials')"
        >
          Success Stories
        </v-btn>
      </div>

      <!-- Action Buttons -->
      <div class="header-actions d-none d-md-flex">
        <v-btn
          text
          class="login-btn"
          @click="loginAgent"
        >
          Login
        </v-btn>
        <v-btn
          class="signup-btn"
          dark
          @click="signUpAgent"
        >
          Get Started
        </v-btn>
      </div>

      <!-- Mobile Menu - Only visible on mobile -->
      <v-menu
        offset-y
        class="d-md-none mobile-menu-container"
        :close-on-content-click="true"
        :z-index="9999"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            v-bind="attrs"
            v-on="on"
            class="mobile-menu-btn d-md-none"
          >
            <v-icon class="material-icons-round">menu</v-icon>
          </v-btn>
        </template>
        <v-list class="mobile-menu">
          <v-list-item @click="scrollToSection('features')">
            <v-list-item-title>Features</v-list-item-title>
          </v-list-item>
          <v-list-item @click="scrollToSection('how-it-works')">
            <v-list-item-title>How It Works</v-list-item-title>
          </v-list-item>
          <v-list-item @click="scrollToSection('testimonials')">
            <v-list-item-title>Success Stories</v-list-item-title>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item @click="loginAgent">
            <v-list-item-title>Login</v-list-item-title>
          </v-list-item>
          <v-list-item @click="signUpAgent">
            <v-list-item-title>Get Started</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-container>
  </v-app-bar>
</template>

<script>
export default {
  name: 'HeaderAgent',
  methods: {
    scrollToSection(sectionId) {
      this.$nextTick(() => {
        const element = document.querySelector(`.${sectionId}-section`);
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      });
    },

    loginAgent() {
      // Navigate to agent login
      this.$router.push('/login');
    },

    signUpAgent() {
      // Navigate to agent signup
      this.$router.push('/signup');
    }
  }
}
</script>

<style scoped>
.agent-header {
  border-bottom: 1px solid #e9ecef;
  backdrop-filter: blur(10px);
  background: rgba(255, 255, 255, 0.95) !important;
  z-index: 1000 !important;
}

.agent-logo {
  display: flex;
  align-items: center;
}

.logo-link {
  display: flex;
  align-items: center;
  text-decoration: none;
  gap: 12px;
}

.logo-image {
  transition: transform 0.3s ease;
}

.logo-image:hover {
  transform: scale(1.05);
}

.logo-text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.brand-name {
  font-size: 1.5rem;
  font-weight: 700;
  color: #1a202c;
  line-height: 1;
  margin-bottom: 2px;
  font-family: 'Inter', sans-serif;
  letter-spacing: -0.02em;
}

.agent-badge {
  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
  color: white;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.3);
  transition: all 0.3s ease;
}

.header-nav {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-right: 32px;
}

.nav-btn {
  color: #495057 !important;
  font-weight: 600 !important;
  text-transform: none !important;
  font-size: 0.95rem !important;
  padding: 8px 16px !important;
  border-radius: 8px !important;
  transition: all 0.3s ease !important;
}

.nav-btn:hover {
  background: #f8f9fa !important;
  color: #007bff !important;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.login-btn {
  color: #495057 !important;
  font-weight: 600 !important;
  text-transform: none !important;
  font-size: 0.95rem !important;
  padding: 8px 20px !important;
  border-radius: 8px !important;
  transition: all 0.3s ease !important;
}

.login-btn:hover {
  background: #f8f9fa !important;
  color: #007bff !important;
}

.signup-btn {
  background: linear-gradient(135deg, #007bff 0%, #0056b3 100%) !important;
  color: white !important;
  font-weight: 600 !important;
  text-transform: none !important;
  font-size: 0.95rem !important;
  padding: 10px 24px !important;
  border-radius: 8px !important;
  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.3) !important;
  transition: all 0.3s ease !important;
}

.signup-btn:hover {
  transform: translateY(-1px) !important;
  box-shadow: 0 6px 20px rgba(0, 123, 255, 0.4) !important;
}

.mobile-menu-btn {
  color: #495057 !important;
}

.mobile-menu-container {
  z-index: 9999 !important;
}

.mobile-menu {
  min-width: 200px;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  z-index: 9999 !important;
  position: relative;
}

.mobile-menu .v-list-item {
  padding: 12px 20px;
  font-weight: 600;
  color: #495057;
  transition: all 0.3s ease;
}

.mobile-menu .v-list-item:hover {
  background: #f8f9fa;
  color: #007bff;
}

/* Responsive Design */
@media (min-width: 961px) {
  .mobile-menu-btn {
    display: none !important;
  }

  .mobile-menu-container {
    display: none !important;
  }
}

@media (max-width: 960px) {
  .logo-text {
    display: none;
  }

  .agent-logo {
    margin-right: auto;
  }

  .header-nav {
    display: none !important;
  }

  .header-actions {
    display: none !important;
  }

  .mobile-menu-btn {
    display: flex !important;
  }
}

@media (max-width: 600px) {
  .agent-header {
    height: 70px;
  }

  .logo-image {
    height: 60px;
  }

  .mobile-menu {
    min-width: 180px;
    margin-top: 8px;
  }
}
</style>
